export const CATEGORIES = [
  "Chill", "DJ Set", "Aperitivo", "Cocktail Bar", "Promo",
  "Pub", "Musica Live", "Wine Bar", "Rooftop",
];

export const NEIGHBORHOOD_COORDS = {
  "Duomo": [45.4642, 9.1900],
  "Brera": [45.4719, 9.1881],
  "Navigli": [45.4483, 9.1722],
  "Isola": [45.4869, 9.1875],
  "Porta Romana": [45.4515, 9.2045],
  "Corso Como": [45.4808, 9.1877],
  "Porta Venezia": [45.4745, 9.2050],
  "Ticinese": [45.4530, 9.1820],
  "Città Studi": [45.4780, 9.2270],
  "Loreto": [45.4870, 9.2160],
  "Porta Nuova": [45.4820, 9.1920],
  "Garibaldi": [45.4818, 9.1860],
  "Sempione": [45.4756, 9.1730],
  "Chinatown (Sarpi)": [45.4830, 9.1780],
  "Lambrate": [45.4850, 9.2380],
  "NoLo": [45.4930, 9.2180],
  "Bicocca": [45.5150, 9.2120],
  "San Siro": [45.4780, 9.1220],
  "Porta Genova": [45.4530, 9.1700],
  "Fiera / Wagner": [45.4700, 9.1500],
  "CityLife": [45.4790, 9.1560],
  "Sant'Ambrogio": [45.4620, 9.1750],
  "Cadorna": [45.4680, 9.1770],
  "Porta Vittoria": [45.4620, 9.2130],
  "Tortona": [45.4520, 9.1620],
  "Bovisa": [45.5030, 9.1600],
  "Dergano": [45.5000, 9.1830],
  "Corvetto": [45.4380, 9.2200],
};

export const NEIGHBORHOODS = Object.keys(NEIGHBORHOOD_COORDS);

export const MILAN_CENTER = [45.4642, 9.19];

export const CONTACT_EMAIL = "wydita.info@protonmail.com";

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function isToday(dateStr) {
  return !!dateStr && dateStr === todayISO();
}

export function formatDateIt(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return dateStr;
  }
}

export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export const EXTRA_ZONES = ["Hinterland / fuori Milano", "Altra zona"];
export const NEIGHBORHOOD_OPTIONS = [...NEIGHBORHOODS, ...EXTRA_ZONES];
export const isExtraZone = (n) => EXTRA_ZONES.includes(n);

export const zoneOf = (e) => {
  const n = e?.neighborhood || "";
  return isExtraZone(n) ? (e.zone_text || n) : n;
};

export const placeOf = (e) => zoneOf(e) || [e?.venue_name, e?.address].filter(Boolean).join(" · ");

export const RECURRENCE_OPTIONS = [
  { value: "none", label: "Non si ripete" },
  { value: "weekly", label: "Ogni settimana" },
  { value: "biweekly", label: "Ogni 2 settimane" },
  { value: "monthly", label: "Ogni mese (stesso giorno della settimana)" },
];
